import { ref, computed } from 'vue';
import BroadcastApi from '../api/broadcasts';

export function useBroadcasts() {
  const broadcasts = ref([]);
  const isLoading = ref(false);
  const error = ref(null);
  const lastUpdateTime = ref(null);

  const fetchBroadcasts = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const response = await BroadcastApi.get();
      broadcasts.value = response.data;
      lastUpdateTime.value = new Date();
    } catch (err) {
      error.value = err;
      throw new Error(`Failed to fetch broadcasts: ${err}`);
    } finally {
      isLoading.value = false;
    }
  };

  const activeBroadcasts = computed(() => {
    return broadcasts.value.filter(b =>
      ['sending', 'queued', 'scheduled', 'running'].includes(b.status)
    );
  });

  const historyBroadcasts = computed(() => {
    return broadcasts.value.filter(b =>
      ['completed', 'failed', 'cancelled'].includes(b.status)
    );
  });

  return {
    broadcasts,
    activeBroadcasts,
    historyBroadcasts,
    isLoading,
    error,
    lastUpdateTime,
    fetchBroadcasts,
  };
}
